import {NgModule} from '@angular/core';
import {TextileDataSharedModule} from '@presentation/pages/textile-data/textile-data-shared.module';
import {SelectUnitComponent} from './add/counter/add/select-unit/select-unit.component';

@NgModule({
  imports: [TextileDataSharedModule],
  declarations: [SelectUnitComponent],
  exports: [SelectUnitComponent]
})
export class DeviceTemplateSharedModule {}
